declare const window: { gtag: (...args: any[]) => void }

export function trackEvents(name: string, value?: string) {
  if (window.gtag && name) {
    window.gtag('event', name, value)
  }
}
